import Button from 'atoms/Button/Button';
import Stack from 'atoms/Layout/Stack/Stack';
import HeadingAndSupportingTextWithActions from 'molecules/HeadingAndSupportingText/HeadingAndSupportingTextWithActions';
import React from 'react';

const ThankYouMessage = (): JSX.Element => (
  <Stack>
    <HeadingAndSupportingTextWithActions
      direction='column'
      gap='spacing-xl'
      heading={{
        text: 'You’re in!',
        type: 'heading',
        size: 'lg',
        textAlign: 'center',
      }}
      supportingText={{
        text: 'The link is also in your inbox',
        type: 'paragraph',
        size: 'md',
        textAlign: 'center',
      }}
      actions={
        <Stack
          marginTop='spacing-xl'
          justify='center'
          align='center'
          maxWidth='width-fit-content'
          margin={['spacing-none', 'spacing-auto']}
        >
          <Button
            variant='primary'
            size='md'
            href='/peoplemagic/masterclass'
          >
            Go to the Masterclass
          </Button>
        </Stack>
      }
    />
  </Stack>
);

export default ThankYouMessage;
